import React, { useContext, useReducer, createContext } from 'react';
import { searchReducer, initialState, SEARCH_ACTIONS } from '../reducers/search.reducer';

/* eslint-disable */
export const CalculatorContext = createContext();

export const CalculatorProvider = ({ children }) => {
  const [state, dispatch] = useReducer(searchReducer, initialState);

  const getAssetData = () => dispatch({ type: SEARCH_ACTIONS.RETRIEVE_ASSET_ADDRESS_INFO });

  const selectAsset = (asset) => {
    dispatch({ type: SEARCH_ACTIONS.SELECT_OPTION, payload: { selectedOption: asset }});
  }

  const value = {
    selectAsset,
    selectedOption: state.selectedOption
  }

  return (
    <CalculatorContext.Provider value={value} >
      {children}
    </CalculatorContext.Provider>
  )
}

export function useCalculatorContext() {
  return useContext(CalculatorContext);
}

export default CalculatorContext;